import React from "react"
import {PesquisarClienteContainer} from "./PesquisarClienteContainer";

declare var window: any

export const PesquisaClienteForaOrcamento = () => {
    return (
        <>
            <PesquisarClienteContainer 
                foraOrcamento={true}
                regiaoRenderizada="pesquisa-clientes-region" 
            />
        </>
)
}

window.PesquisaClienteForaOrcamento = PesquisaClienteForaOrcamento
